"use client";
import Image from "next/image";
import React, { useState } from "react";
import CommonButton from "./CommonButton";
import Link from "next/link";
import { Col, Container, Modal, Row } from "react-bootstrap";
import Dock from "./Dock";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

const ProjectsDetails = ({ project }) => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const images = project?.images.map((img) => ({ src: img }));

  return (
    <div className="pt-5" style={{ paddingBottom: "150px" }}>
      <Container>
        <Row className="gy-4 position-relative">
          <Col lg={12}>
            <div className="d-flex justify-content-between align-items-center">
              <h1 className="big_heading p-0 m-0">{project?.name}</h1>
              {project?.projectLink && (
                <Link
                  href={project?.projectLink || ""}
                  aria-label={`view ${project.title} Live`}
                >
                  <CommonButton label="Visit Live Site" />
                </Link>
              )}
            </div>
            <p className="mt-3" style={{ opacity: 0.5 }}>
              {project.title}
            </p>
          </Col>

          {project?.images.map((img, i) => (
            <Col xl={6} md={12} key={i}>
              <div
                key={i}
                className="image-wrapper mb-3"
                onClick={() => {
                  setIndex(i);
                  setOpen(true);
                }}
              >
                <Image
                  src={img}
                  alt="project"
                  width={500}
                  height={500}
                  className="d-block project-img "
                />
                <div className="overlay">
                  <h2 className="plus-icon">+</h2>
                </div>
              </div>
            </Col>
          ))}

          <Col md={12}>
            <div className="sticky-content">
              <div className="thin_heading text-start mt-2">
                {project?.details[0]}
              </div>
              <div className="web_text text-start mt-2">
                {project?.details[1]}
              </div>
            </div>
          </Col>
          <div className="dock-main d-none d-md-block">
            <Dock
              items={project.icons.map((link, index) => ({
                icon: (
                  <Image
                    src={link?.image}
                    alt={link?.IconLabel}
                    width={30}
                    height={30}
                  />
                ),
                label: link?.IconLabel || "Some label",
                onClick: () => window.open(link?.links, "_blank"),
                className: "dock-link",
              }))}
              panelHeight={68}
              baseItemSize={50}
              magnification={70}
            />
          </div>
          <div className="d-flex d-md-none flex-wrap gap-3 justify-content-center align-items-center">
            {project.icons.map((link, index) => (
              <Link
                key={index}
                href={link?.links || "#"}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 border rounded"
                aria-label={`Go to ${link?.IconLabel}`}
              >
                <Image
                  src={link?.image}
                  alt={link?.IconLabel}
                  width={30}
                  height={30}
                />
              </Link>
            ))}
          </div>
        </Row>
      </Container>

      {/* Modal for enlarged image */}
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        index={index}
        slides={images}
      />
    </div>
  );
};

export default ProjectsDetails;
